type Props = {
  letter: string;
  abbreviation: string | null;
};

export function LetterBadge({ letter, abbreviation }: Props) {
  return (
    <div className="flex items-center gap-2 text-xs">
      <span className="inline-flex items-center justify-center w-7 h-7 rounded-lg bg-bg border border-outline font-mono font-bold text-fg-soft">
        {letter}
      </span>
      {abbreviation && (
        <span className="px-2 py-1 rounded-md bg-accent-soft border border-accent/30 text-accent font-mono font-semibold tracking-wide">
          {abbreviation}
        </span>
      )}
    </div>
  );
}
